import { RaffleDrawTypeEnum, RaffleDrawTypeTypes } from "@hooks/enums/raffle";

const raffleDrawTypes = {
  [RaffleDrawTypeEnum.FEDERAL_LOTTERY]: {
    title: "Sorteio pela Loteria Federal",
    description: "O resultado da campanha será baseado no sorteio oficial da Loteria Federal.",
  },
  [RaffleDrawTypeEnum.RANDOM_NUMBER]: {
    title: "Sorteio aleatório entre bilhetes vendidos",
    description: "O vencedor será escolhido aleatoriamente entre os bilhetes vendidos da campanha.",
  },
};

export const getRaffleDrawType = (type?: RaffleDrawTypeTypes) => type ? raffleDrawTypes[type] : undefined;
